import { memo } from 'react';

import useLocalStorage from '@zenbusiness/application-commons-hooks/useLocalStorage';
import Box from '@zenbusiness/zui/Box';
import DismissBanner from '@zenbusiness/zui/DismissBanner';
import LoadingButton from '@zenbusiness/zui/LoadingButton';

import { ActionButtonsGrid } from '#client/components/Grid';
import RenderIf from '#client/components/RenderIf';
import { ZEN_DOWNLOAD_APP_URL } from '#client/constants/url';
import useConstBusinessEntityUuid from '#client/hooks/useConstBusinessEntityUuid';
import useFormStep from '#client/hooks/useFormStep';
import { checkIsMobile } from '#client/utils/devices';

import { DialogContentStyled } from './CheckDepositEducation.styles';
import CheckDepositIntro from './CheckDepositIntro';

import { MODAL_ACTION } from '../constants/actions';

const CheckDepositEducation = () => {
  const { dispatchDepositData } = useFormStep();
  const { businessEntityUuid } = useConstBusinessEntityUuid();
  const isMobile = checkIsMobile();

  const handleOpenDepositModal = () => {
    dispatchDepositData({ type: MODAL_ACTION.GO_OVERVIEW });
  };

  const [isDismissed] = useLocalStorage(
    `dismissed_deposit_check_app_banner.${businessEntityUuid}`,
    false
  );

  return (
    <>
      <DialogContentStyled>
        <RenderIf when={isMobile && !isDismissed}>
          <Box
            sx={{
              margin: '0 5%'
            }}
          >
            <DismissBanner
              slotProps={{
                primaryAction: {
                  label: 'Download',
                  onClick: () => {
                    window.open(ZEN_DOWNLOAD_APP_URL, '_blank');
                  }
                }
              }}
              storageKey={`dismissed_deposit_check_app_banner.${businessEntityUuid}`}
              subtitle="Get the app for a fast, simple experience."
              title="Deposit checks in our app"
              variant="info"
            />
          </Box>
        </RenderIf>
        <CheckDepositIntro isCheckDepositEducation />
      </DialogContentStyled>
      <ActionButtonsGrid>
        <LoadingButton
          color="primary"
          fullWidth
          onClick={handleOpenDepositModal}
          variant="contained"
        >
          I&apos;m ready
        </LoadingButton>
      </ActionButtonsGrid>
    </>
  );
};

export default memo(CheckDepositEducation);
